var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bubble",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    fill: "#0171B9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.789,15.012v47.334c0,5.514-4.486,10-10,10H50.122L32.376,90.039l0.003,0.003l-0.004-0.001l-0.056,0.056l-0.098-0.098 l-8.765-2.369l3.219-3.193l-0.006-0.006l20.146-20.084h34.974c1.084,0,2-0.916,2-2V15.012c0-1.084-0.916-2-2-2H13.808 c-1.094,0-2.019,0.925-2.019,2.019v47.315c0,1.084,0.916,2,2,2h6.956c4.404,0,8.006,3.583,8.03,7.987l0.029,1.874l0.004,0 l-0.004,0.004l0.001,0.079l-0.079,0.001l-7.803,8.033l-0.109-7.914l-0.008,0l-0.03-1.996l-6.986-0.069c-5.514,0-10-4.486-10-10 V15.031c0-5.524,4.495-10.019,10.019-10.019h67.981C87.303,5.012,91.789,9.498,91.789,15.012z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/bubble.0aa0396521a4556ba120a733e38bd97d.svg";
export { ForwardRef as ReactComponent };